<header id="page-topbar" [ngClass]="{'page-topbar': titleLogoText === 'FFM', 'page-topbar-prspr' : titleLogoText === 'PRSPR', 'page-topbar-cpjp' : titleLogoText === 'CPJP' }">
    <div class="d-flex flex-row flex-space-between">
        <div class="d-flex">
            <div class="d-flex" style="align-items: center;">
                <button type="button" class="btn btn-sm header-item topbar-mobile-menu-toggle"
                    (click)="toggleMobileMenu($event)" [attr.aria-label]="'OPEN_NAVIGATION_MENU' | translate">
                    <i class="fa fa-fw fa-bars"></i>
                </button>
                <div
                    [ngClass]="(activePage !== PAGE_NAMES.Subscriptions) ? 'right-element page-title-anchor' : 'right-element page-title-anchor hide-from-980'">
                    <span class="page-title">
                        <h1>{{ (appService.getPageTitle$() | async) | uppercase}}</h1>
                    </span>
                </div>
            </div>
        </div>
        <div class="d-flex dv-date align-items-center right-element">

        </div>
        <div class="d-flex flex-row top-header-right hide-from-768" style="align-items: center !important;">
            <!-- Language Switcher Dropdown -->
            <div style="margin-right: 15px;">
                <ng-select
                    [(ngModel)]="cookieValue"
                    [clearable]="false"
                    [searchable]="false"
                    class="custom topbar-select lang-select"
                    (ngModelChange)="setLanguage($event)">
                    <ng-option *ngFor="let lang of languages" [value]="lang.code">{{ lang.label }}</ng-option>
                </ng-select>
            </div>
            <div *ngIf="showGoToInstanceBtn" style="margin-right: 15px;">
                <ng-select [(ngModel)]="selectedInstanceText" [clearable]="false" [searchable]="false" class="custom topbar-select" (change)="GotoAnotherInstance()">
                    <ng-option *ngIf="showFFM" value="FFM">FFM</ng-option>
                    <ng-option *ngIf="showPRSPR" value="PRSPR">PRSPR</ng-option>
                    <ng-option *ngIf="showCPJP" value="CPJP">Kommunity</ng-option>
                </ng-select>
            </div>

            <div class="topbar-search-shell">
                <i-feather name="search" class="topbar-search-icon"></i-feather>
                <input type="text" [placeholder]="'SEARCH' | translate" class="form-control form-control-sm ms-2 topbar-search-input"
                    [(ngModel)]="searchKeyword"
                    (keyup.enter)="search()">
            </div>

            <div class="topbar-user-settings dropdown d-inline-block" ngbDropdown>
                <button
                    type="button"
                    class="topbar-user-settings__trigger"
                    id="topbar-user-settings-dropdown"
                    ngbDropdownToggle
                    [attr.aria-label]="'OPEN_USER_SETTINGS' | translate">
                    <span class="topbar-user-settings__initials">{{ currentUserInitials }}</span>
                </button>

                <div class="dropdown-menu dropdown-menu-end topbar-user-settings__menu" ngbDropdownMenu aria-labelledby="topbar-user-settings-dropdown">
                    <button type="button" class="dropdown-item topbar-user-settings__item" (click)="openEditUserModal()">
                        <span class="topbar-user-settings__item-title">{{ 'EDIT_USER' | translate }}</span>
                        <span class="topbar-user-settings__item-copy">{{ 'UPDATE_YOUR_USER_RECORD' | translate }}</span>
                    </button>
                    <button *ngIf="!externalUser && !instance.isAltLayout" type="button" class="dropdown-item topbar-user-settings__item" (click)="openDashboardStylesModal()">
                        <span class="topbar-user-settings__item-title">{{ 'DASHBOARD_SETTINGS' | translate }}</span>
                        <span class="topbar-user-settings__item-copy">{{ 'TASKS_AND_DMS_DASHBOARD' | translate }}</span>
                    </button>
                    <button type="button" class="dropdown-item topbar-user-settings__item" (click)="toggleThemeMode()">
                        <span class="topbar-user-settings__item-title">{{ getThemeToggleLabel() | translate }}</span>
                        <span class="topbar-user-settings__item-copy">{{ 'SWITCH_MODE' | translate }}</span>
                    </button>
                    <button *ngIf="!externalUser" type="button" class="dropdown-item topbar-user-settings__item" (click)="toggleDensityMode()">
                        <span class="topbar-user-settings__item-title">{{ densityMode === 'condensed' ? ('COMFORTABLE_MODE' | translate) : ('CONDENSED_MODE' | translate) }}</span>
                        <span class="topbar-user-settings__item-copy">{{ 'VERTICAL_SPACING' | translate }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</header>
